import "./OperationalEfficiencyAudits.module.css";
import Header from "@/reusable_sections/Header";
import UnlockYourBusinessPotentialWithStreamlinedOperations from "./sections/UnlockYourBusinessPotentialWithStreamlinedOperations";
import OurStreamlinedAuditProcess from "./sections/OurStreamlinedAuditProcess";
import Footer from "@/reusable_sections/Footer";
export default function OperationalEfficiencyAuditsPage() {
  return <div>
      <Header />
      <UnlockYourBusinessPotentialWithStreamlinedOperations />
      <OurStreamlinedAuditProcess />
      <Footer />
    </div>;
}